import React from "react"

import Raw from "@atoms/Raw/Raw"

import styles from "./Script.module.scss"

const Script = ({ script, wide, disableMinHeight }) => {
  return (
    <section className={`${styles.element} ${wide ? "" : "max-vvw"}`}>
      <Raw html={script} disableMinHeight={disableMinHeight} />
    </section>
  )
}

export default Script
